import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('access');
    if (token) {
      api.get('auth/profile/').then(r => setUser(r.data)).catch(() => {
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post('auth/login/', { username, password });
    localStorage.setItem('access', data.access);
    localStorage.setItem('refresh', data.refresh);
    const profile = await api.get('auth/profile/');
    setUser(profile.data);
  };

  const googleLogin = async (credential) => {
    const { data } = await api.post('auth/google/', { token: credential });
    localStorage.setItem('access', data.access);
    localStorage.setItem('refresh', data.refresh);
    const profile = await api.get('auth/profile/');
    setUser(profile.data);
  };

  const register = async (userData) => {
    await api.post('auth/register/', userData);
  };

  const logout = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, googleLogin, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
